import React from 'react';
import { BadgeCheckIcon, CalendarDaysIcon, HouseIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { stats } from '../../data/company';
const icons = [CalendarDaysIcon, HouseIcon, ShieldCheckIcon, BadgeCheckIcon];
export function TrustBar() {
  const {
    b,
    t
  } = useLanguage();
  return <section className="bg-navy py-12" aria-label={t('trust.title')} data-id="element-392" data-mp="3adcwisphfrai">
      <div className="mx-auto grid max-w-page gap-8 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8" data-id="element-393" data-mp="2mnsa1zu4ebwh">
        {stats.map((stat, index) => {
        const Icon = icons[index];
        return <div key={stat.value} className="flex items-center gap-4" data-id="element-394" data-mp="2wdk5sxdyhb2j" data-mpi={index}>
              <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-white/10 text-brand-300" data-id="element-395" data-mp="2rlk3iyaey62s">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-396" data-mp="23uwqjyln4q9d" />
              </span>
              <div data-id="element-397" data-mp="1ywd4ly71reh0">
                <p className="font-display text-3xl font-extrabold leading-none text-white" data-id="element-398" data-mp="1ywv5x98kgivs">{stat.value}</p>
                <p className="mt-1.5 text-sm text-white/70" data-id="element-399" data-mp="2rr96v9qjfhrw">{b(stat.label)}</p>
              </div>
            </div>;
      })}
      </div>
    </section>;
}